import React, { useState, useCallback, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../assets/styles/layers.scss";
import LayersIcon from "../assets/images/server_rgb_red.svg";
import InformationLayerMap from "../components/InformationLayerMap";
import ImportLayerComponent from "../components/Layers/Create/ImportLayerComponent";

const LayerCreateMultiple = () => {
  const [previewLayers, setPreviewLayers] = useState([]); // GeoJSON strings do wyświetlenia na mapie
  const [visibleImported, setVisibleImported] = useState([]); // {area, visible}
  const [focusArea, setFocusArea] = useState(null); // tymczasowy GeoJSON do zoom (FitBounds)
  const [focusKey, setFocusKey] = useState(0); // wymuszenie re-render mapy przy focus

  // Buduj GeoJSON z wielu warstw do wyświetlenia
  const combinedArea = useMemo(() => {
    // Jeśli jest fokus na konkretną warstwę, wyświetl ją (FitBounds się uruchomi)
    if (focusArea) return focusArea;

    const allAreas = [
      ...previewLayers,
      ...visibleImported.filter(l => l.visible).map(l => l.area)
    ];

    if (allAreas.length === 0) return null;

    try {
      const features = allAreas.map(areaStr => {
        const parsed = JSON.parse(areaStr);
        // Jeśli to geometria (Polygon/MultiPolygon), opakuj w Feature
        if (parsed.type === 'Polygon' || parsed.type === 'MultiPolygon') {
          return { type: "Feature", properties: {}, geometry: parsed };
        }
        // Jeśli to już Feature
        if (parsed.type === 'Feature') return parsed;
        return null;
      }).filter(Boolean);

      if (features.length === 0) return null;
      if (features.length === 1) return JSON.stringify(features[0].geometry);

      return JSON.stringify({
        type: "FeatureCollection",
        features
      });
    } catch {
      return null;
    }
  }, [previewLayers, visibleImported, focusArea]);

  // Callback z ImportLayerComponent — podgląd warstw
  const handleLayerPreview = useCallback((geoJsonArray) => {
    setPreviewLayers(geoJsonArray);
    setFocusArea(null);
  }, []);

  // Callback — ukryj/pokaż zaimportowaną warstwę
  const handleLayerToggle = useCallback((index, visible) => {
    setVisibleImported(prev => {
      const updated = [...prev];
      if (updated[index]) {
        updated[index] = { ...updated[index], visible };
      }
      return updated;
    });
    setFocusArea(null);
  }, []);

  // Callback — zoom na warstwę (ustawia focusArea, FitBounds w mapie zrobi zoom)
  const handleLayerFocus = useCallback((areaGeoJson) => {
    setFocusArea(areaGeoJson);
    setFocusKey(prev => prev + 1);
    // Po krótkiej chwili przywróć pełny widok warstw (mapa zostanie przybliżona)
    setTimeout(() => setFocusArea(null), 500);
  }, []);

  return (
    <div className="layers-container">
      <Container fluid>
        <Row className="align-items-center mb-3">
          <Col>
            <div className="d-flex align-items-center">
              <img
                src={LayersIcon}
                alt="Layers Icon"
                style={{ width: "30px", height: "30px", marginRight: "12px" }}
              />
              <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", margin: 0 }}>
                W BUDOWIE - Import warstw z plików SHP - W BUDOWIE
              </h3>
            </div>
          </Col>
        </Row>
        <Row>
          {/* Panel boczny — import */}
          <Col xs={12} md={4}>
            <ImportLayerComponent
              onLayerPreview={handleLayerPreview}
              onLayerToggle={handleLayerToggle}
              onLayerFocus={handleLayerFocus}
            />
          </Col>
          {/* Mapa */}
          <Col xs={12} md={8}>
            <InformationLayerMap
              pins={[]}
              area={combinedArea}
              color="#f09800"
              zoom={7}
              editable={true}
              onAreaUpdate={() => {}}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default LayerCreateMultiple;
